import React, { createContext, useContext, useMemo } from "react";
import { UserContext } from "./UserContext";
import { getSubscriptionSnapshot } from "../utils/subscription";
import { useOwnerQa } from "./OwnerQaContext";

const ProContext = createContext({
  isPro: false,
  loading: true,
  subscription: null,
  refresh: async () => null,
});

export function ProContextProvider({ children }) {
  const { user, loading, refresh } = useContext(UserContext);
  const qa = useOwnerQa();
  const subscription = useMemo(() => getSubscriptionSnapshot(user), [user]);
  const realIsPro = subscription.isPro;
  const qaMode = qa.active ? qa.config.subscriptionMode : "real";
  const isPro = qaMode === "pro"
    ? true
    : qaMode === "trial"
      ? qa.hoodAccess?.phase === "trial"
      : qaMode === "free"
        ? false
        : realIsPro;

  const value = useMemo(
    () => ({
      isPro,
      realIsPro,
      qaMode,
      loading,
      subscription,
      refresh,
    }),
    [isPro, loading, qa.hoodAccess?.phase, qaMode, realIsPro, refresh, subscription]
  );

  return <ProContext.Provider value={value}>{children}</ProContext.Provider>;
}

export function usePro() {
  return useContext(ProContext);
}
